import { PlusCircleSVG } from 'common/assets';
import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import Guest from './guest';
import { addNewPurchase } from '../../hooks/use-get-default-values';
import { ActivityPurchaseFormType } from '../form-type';

export default function ActivityDetailSection() {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const { control, getValues } = useFormContext<ActivityPurchaseFormType>();
  const { append, remove } = useFieldArray({
    control,
    name: 'activityPurchases',
    keyName: '__customId',
  });

  const activityPurchases = getValues('activityPurchases');

  const onAddActivity = React.useCallback(() => {
    append(addNewPurchase());
  }, [append]);

  const onRemoveActivity = React.useCallback(
    (index) => remove(index),
    [remove],
  );

  return (
    <>
      {(activityPurchases || []).map((activityPurchase, index) => (
        <React.Fragment key={activityPurchase.customId}>
          <Guest
            parentIndex={index}
            onRemove={() => onRemoveActivity(index)}
            fieldLength={activityPurchases.length}
          />
          <SeparatorVertical $margin={36} />
        </React.Fragment>
      ))}
      {editable && (
        <>
          <SeparatorHorizontal $margin={16} />
          <Button
            startEnhancer={(color, size) => (
              <PlusCircleSVG color={color} size={size} />
            )}
            buttonType="secondary"
            onClick={onAddActivity}
          >
            {t('common:add')}
          </Button>
        </>
      )}
    </>
  );
}
